import React, { ReactNode, Ref, ComponentPropsWithoutRef } from 'react';

type ElType = {
	div: HTMLDivElement;
	span: HTMLSpanElement;
	h3: HTMLHeadingElement;
	p: HTMLParagraphElement;
	img: HTMLImageElement;
};

interface InteractiveElementProps<T extends keyof ElType> {
	type: T;
	children?: ReactNode;
	alt?: T extends 'img' ? string : never; // Optional alt for img type
}

const InteractiveElement = React.forwardRef(
	<T extends keyof ElType>(
		{
			type,
			children,
			alt,
			...rest
		}: InteractiveElementProps<T> & ComponentPropsWithoutRef<T>,
		ref: Ref<ElType[T]>,
	) => {
		switch (type) {
			case 'span':
				return (
					<span ref={ref as Ref<HTMLSpanElement>} {...rest}>
						{children}
					</span>
				);
			case 'img':
				return (
					<img ref={ref as Ref<HTMLImageElement>} alt={alt ?? ''} {...rest} />
				);
			case 'p':
				return (
					<p ref={ref as Ref<HTMLParagraphElement>} {...rest}>
						{children}
					</p>
				);
			case 'h3':
				return (
					<h3 ref={ref as Ref<HTMLHeadingElement>} {...rest}>
						{children}
					</h3>
				);
			case 'div':
			default:
				return (
					<div ref={ref as Ref<HTMLDivElement>} {...rest}>
						{children}
					</div>
				);
		}
	},
);

export default InteractiveElement;
